const validationRules = {
    email: [
        val => !!val || 'E-mail is required',
        val => /.+@.+/.test(val) || 'E-mail must be valid'
    ],
    password: [
        val => !!val || 'Password is required',
        val => (val && (val.length >= 8 && val.length <= 16)) || 'Password must be between 8 and 16 characters'
    ],
    firstName: [
        val => !!val || 'First name is required',
        val => (val && (val.length >= 2 && val.length <= 32)) || 'First name must be between 2 and 32 characters'
    ],
    lastName: [
        val => !!val || 'Last name is required',
        val => (val && (val.length >= 2 && val.length <= 32)) || 'First name must be between 2 and 32 characters'
    ],
    title: [
        v => !!v || 'Title is required',
        v => (v && (v.length > 3 && v.length <= 100)) || 'Title must be between 3 and 100 characters'
    ],
    titleShort: [
        v => !!v || 'Title is required',
        v => (v && (v.length >= 2 && v.length <= 100)) || 'Title must be between 2 and 100 characters'
    ],
    description: [
        v => (v && v.length <= 10000) || 'Description must be less then 10000'
    ],
    select: [
        v => !!v || 'Please select correct value from the list'
    ],
    required: value => (!!value && !!value.trim()) || 'Required',
    requiredNumber: value => (value && !!value) || 'Required'
}

export default validationRules
